module.exports = __webpack_public_path__ + "static/purchaseError-6de2c676cf8e97be01243851fd1df2c9.mp3";